'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (err, props) {
  if (err) {
    return 500;
  }

  var isNotFound = props.routes.find(function (route) {
    return route.path === '*';
  });
  if (props && !isNotFound) {
    return 200;
  }

  return 404;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/boilerplate/utils/get-status.js
// module id = 581
// module chunks = 0